<template>
    <!--权限管理-->
    <div :class="phoneClass" class="authority-list">
        <content-header>
            <el-button v-if="user.role === 100" type="primary" class="authority-button" @click="goAuthorityAdd" >
                <img src="../../assets/img/btn/icon-add.png" >
                <span class="text">{{$t('authority.new_group')}}</span>
            </el-button>
        </content-header>
        <div class="wrapper" ref="wrapper">
                <div class="authority-section" v-if="groupList.length">
                    <div class="authority-table" v-for="item in groupList" :key="item.id">
                        <div class="authority-table-group">
                            {{$t('authority.group_name')}}：{{item.name}} <el-button v-if="canOperate" type="success" plain @click="addPeople(item.leader[0].group_id)"><span>+</span> {{$t('authority.add_member')}}</el-button>
                        </div>
                        <div class="authority-table-section">
                            <div class="authority-table-class">
                                <span>{{$t('authority.name')}}</span>
                                <span>{{$t('authority.phone')}}</span>
                                <span>{{$t('authority.identity')}}</span>
                                <span>{{$t('authority.state')}}</span>
                                <span>{{$t('authority.create_time')}}</span>
                                <span>{{$t('setting.microsoft_authenticator')}}</span>
                                <span v-if="canOperate">{{$t('authority.operation')}}</span>
                            </div>
                            <div class="authority-table-child" v-for="(leader,index) in item.leader" :key="leader.id">
                                <span>{{leader.username}}</span>
                                <span>{{leader.phone}}</span>
                                <span>{{$t('authority.group_leader')}}</span>
                                <span style="color: #31C27C;" v-if="leader.is_enable === 0">{{$t('authority.start')}}</span>
                                <span  v-else>{{$t('authority.disables')}}</span>
                                <span>{{leader.create_time | timeFormat(2)}}</span>
                                <span>
                                    <el-switch v-if="canManageMfa(item, leader)" :value="leader.is_mfa_enable === 1" :disabled="leader.mfaPending === true" active-color="#13ce66" inactive-color="#ff4949" @change="changeMfa(item, leader, $event)"></el-switch>
                                    <template v-else>{{leader.is_mfa_enable === 1 ? $t('setting.open') : $t('setting.close')}}</template>
                                </span>
                                <span v-if="canOperate">
                                    <img @click="addPeople(item.leader[0])" v-if="true" style="cursor:pointer" src="../../assets/img/icon/authority-set.png" alt="">
                                    <img v-if="!leader.is_enable" @click="enable(item,'')" style="cursor:pointer" src="../../assets/img/icon/authority-no.png" alt="">
                                    <img v-else @click="enable(item,'')" style="cursor:pointer" src="../../assets/img/icon/authority-off.png" alt="">
                                    <img @click="delPeople(item,index+1,'')" style="cursor:pointer" src="../../assets/img/icon/authority-del.png" alt="">
                                </span>
                            </div>
                            <div class="authority-table-child" v-for="(member, index) in item.member" :key="index">
                                <span>{{member.username}}</span>
                                <span>{{member.phone}}</span>
                                <span>{{$t('authority.team_member')}}</span>
                                <span style="color: #31C27C;" v-if="member.is_enable === 0">{{$t('authority.start')}}</span>
                                <span  v-else>{{$t('authority.disables')}}</span>
                                <span>{{member.create_time | timeFormat(2)}}</span>
                                <span>
                                    <el-switch v-if="canManageMfa(item, member)" :value="member.is_mfa_enable === 1" :disabled="member.mfaPending === true" active-color="#13ce66" inactive-color="#ff4949" @change="changeMfa(item, member, $event)"></el-switch>
                                    <template v-else>{{member.is_mfa_enable === 1 ? $t('setting.open') : $t('setting.close')}}</template>
                                </span>
                                <span v-if="canOperate">
                                    <img @click="addPeople(member)" v-if="true" style="cursor:pointer" src="../../assets/img/icon/authority-set.png" alt="">
                                    <img v-if="!member.is_enable" @click="enable('',member)" style="cursor:pointer" src="../../assets/img/icon/authority-no.png" alt="">
                                    <img v-else @click="enable('',member)" style="cursor:pointer" src="../../assets/img/icon/authority-off.png" alt="">
                                    <img @click="delPeople('','',member)" style="cursor:pointer" src="../../assets/img/icon/authority-del.png" alt="">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="authority-table">
                    </div>
                </div>
                <div class="authority-section" v-else>
                    <div class="authority-table">
                        <div class="authority-table-section">
                            <div class="authority-table-class" style="text-align: center">
                                <span >{{$t('authority.no_group')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="authority-table">
                    </div>
                </div>
        </div>


    </div>
</template>

<script>
    import contentHeader from '../../components/content-header'
    import Core from "core/core";
    import {refresh} from "core/winSize"
    import BScroll from 'better-scroll'
    export default {
        data(){
            return {
                phoneClass: '',
                user: '',
	            userId: '',
                groupId: '',
                groupList: [],
                leaderList: ''
            }
        },
        components: {
            contentHeader,
        },
        computed: {
            /** 组员仅查看分组信息，管理入口仅对客户和组长展示。 */
            canOperate() {
                return this.user.role === 100 || this.user.role === 101;
            },
        },
	    created() {
		    refresh(this,'phoneClass-authority-list');
		    window.onresize = function(){
			    setTimeout(function(){
				    refresh(this,'phoneClass-authority-list');
			    },10)
		    };
	    },
        mounted() {
	        this.$nextTick(() => {
		        //$refs绑定元素
		        if(!this.scroll){
			        this.scroll = new BScroll(this.$refs.wrapper, {
				        //开启点击事件 默认为false
				        click: true,
				        scrollY: true,
				        scrollX: true,
			        })
			        // console.log(this.scroll)
		        }else if(!this.$refs.wrapper){
			        return
		        }
		        else{
			        this.scroll.refresh()
		        }
	        })
            this.initList()
            this.initUser()
        },
        methods: {
            /** 客户管理所属分组的组长和组员，组长仅管理本组组员的 MFA。 */
            canManageMfa(group, account) {
                if (!this.user || !group || !account || !group.id || account.group_id !== group.id) {
                    return false;
                }
                if (this.user.role === 100) {
                    return group.user_id === this.user.id && (account.role === 101 || account.role === 102);
                }
                return this.user.role === 101 && this.user.group_id === group.id && account.role === 102;
            },
            /** 切换成功后更新状态，请求期间禁止重复操作，失败时保留原状态。 */
            changeMfa(group, account, enable) {
                if (!this.canManageMfa(group, account) || account.mfaPending) {
                    return;
                }
                this.$set(account, 'mfaPending', true);
                Core.Api.User.mfaEnable(account.id, enable ? 1 : 0).then(() => {
                    this.$set(account, 'is_mfa_enable', enable ? 1 : 0);
                    this.$message.success(enable ? '已开启 Microsoft Authenticator' : '已关闭 Microsoft Authenticator');
                }).catch(error => {
                    console.error('切换 MFA 状态失败', error);
                    this.$message.error('MFA 状态修改失败，请确认账号具有操作权限');
                }).finally(() => {
                    this.$set(account, 'mfaPending', false);
                });
            },
            initUser(){
              this.user = Core.Data.getUser()
            },
            goAuthorityAdd(){
                if (this.user.role !== 100) {
                    return;
                }
                this.$router.push('/authority/add')
            },
            addPeople(val){
                if (!this.canOperate) {
                    return;
                }
                console.log(val);
	            val.id  ? this.userId = val.id : this.userId = ''
	            val.group_id ? this.groupId = val.group_id : this.groupId = val
                this.$router.push('/authority/addMember?userId=' + this.userId + '&groupId=' + this.groupId )
            },
            delPeople(item,index,member){
                if (!this.canOperate) {
                    return;
                }
                let groupId = ''
                let msg = ''
                member ? groupId = member.id : groupId = item.leader[0].group_id
                index ? msg= '您确定要删除该组组长及该组的所有组员吗？该操作会将该组与设备的关系解绑,且删除该分组！': msg= '您确定删除该组员吗？'
                this.$confirm( msg , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (!member) {
                        Core.Api.Group.deleteGroup(groupId).then((res)=>{
                            this.initList()
                        })
                    } else {
                        Core.Api.User.deleteUser(groupId).then((res)=>{
                            this.initList()

                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        })
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            initList(){
                Core.Api.Group.getGroupList().then(res=>{
                    console.log(res,'getGroupList');
                    let groupList = res.list
                    this.groupList = groupList
                })
            },
            enable (item,member){
                if (!this.canOperate) {
                    return;
                }
                console.log(item,'item');
                console.log(member,'member');
                let userId= ''
                if (member) {
                    userId = member.id
                    if (member.is_enable) {
                        Core.Api.User.enable(userId).then(res=>{
                            this.initList()
                            console.log('禁用成功？')
                        })
                    } else {
                        this.$confirm('您确定要禁用该客户吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            Core.Api.User.enable(userId).then(res=>{
                                this.initList()
                                this.$message({
                                    type: 'success',
                                    message: '禁用成功!'
                                });
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消禁用'
                            });
                        });
                    }
                } else {
                    userId = item.leader[0].id
                    if (item.leader[0].is_enable) {
                        Core.Api.User.enable(userId).then(res=>{
                            this.initList()
                        })
                    } else {
                        this.$confirm('您确定要禁用该客户吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            Core.Api.User.enable(userId).then(res=>{
                                this.initList()
                                this.$message({
                                    type: 'success',
                                    message: '禁用成功!'
                                });
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消禁用'
                            });
                        });
                    }
                }

            }
        },
        
    }
</script>

<style scoped lang="scss">
    @import '../../assets/style/mixin.scss';
    .authority-list {
        background-color: #E5EBEF;
        height: 100%;
        .authority-button {
            background: #0A3D95;
            border:1px white solid;
            img {
                width: 13px !important;
                height: 13px !important;
                vertical-align: middle;
            }
            .text {
                font-size: 14px;
                color: #FFFFFF;
                vertical-align: middle;
                margin-left: 8px;
                line-height: 20px;
            }
        }
        .authority-section {
            width: 94%;
            margin: 0 auto;
            min-width: 600px;
            .authority-table {
                background: white;
                font-size: 22px;
                color: #363D42;
                margin-top: 30px;
                .authority-table-group {
                    border-bottom: 1px #ECF0F4 solid;
                    padding: 14px 20px;
                    position: relative;
                    button {
                        position: absolute;
                        top: 8px;
                        right: 20px;
                        >span {
                            font-size: 20px;

                        }
                    }

                }
                .authority-table-section{
                    padding: 20px;
                    .authority-table-class, .authority-table-child {
                        display: flex;
                        align-items: center;
                        >span {
                            flex-shrink: 0;
                            box-sizing: border-box;
                            overflow-wrap: break-word;
                        }
                    }
                    span {
                        display: inline-block;
                    }
                    .authority-table-class {
                        background: #F5F8FA;
                        padding: 10px 20px;
                        border-bottom: 1px #EDEFF3 solid;

                    }
                    .authority-table-child {
                        padding: 18px 20px;
                        border-bottom: 1px #EBEDF3 solid;

                        img {
                            height: 16px;
                            margin-right: 30px;
                        }
                        >:nth-child(1) {
                            padding-left: 20px;
                        }
                    }
                    div:nth-child(2){
                        background: #F5F8FA;
                        :nth-child(1) {
                            padding-left: 0;
                        }
                    }
                    div span:nth-child(1) {
                        width: 11%;
                    }
                    div span:nth-child(2) {
                        width: 15%;
                    }
                    div span:nth-child(3) {
                        width: 10%;
                    }
                    div span:nth-child(4) {
                        width: 9%;
                    }
                    div span:nth-child(5) {
                        width: 23%;
                    }
                    div span:nth-child(6) {
                        width: 18%;
                    }
                    div span:nth-child(7) {
                        width: 14%;
                    }

                }
            }
        }
        .authority-section-else {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translateX(-50%);
        }
    }

</style>
<style lang="scss">
    .phoneClass-authority-list {
    .phoneClass-content-header-wrapper {
        .header-right{
            position: absolute;
            right: 5px;
        }
    }
        .wrapper {
            width: 100vw;
            height: 93vh;
            overflow: hidden;
            .authority-section{
                min-height: 100vh;
                min-width: 1240px;
                .authority-table {
                    .authority-table-section{
                        /*>div {*/
                            /*width: 1300px;*/
                            /*>span {*/
                                /*width: 200px !important;*/
                            /*}*/
                        /*}*/
                    }
                }
            }

        }
    }
</style>
